module.exports = __webpack_public_path__ + "img/pavl1.1553ac07.jpg";